export default __webpack_public_path__ + "static/media/stopover_moon.2de742fd.svg";